import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  modules: []
}

export const aiSkillsPractice = createSlice({
  name,
  initialState,
  reducers: {
    setModules: (state, { payload }) => {
      state.modules = payload.modules ?? []
    },
    setModuleProgress: (state, { payload }) => {
      const updated = state.modules.map(module => {
        const moduleId = module.scormCourseId ?? module.pk
        if (moduleId === payload.courseId) {
          return {
            ...module,
            userProgress: {
              status: payload.status,
              progress: payload.progress,
              lastAccessedAt: payload.lastAccessedAt ?? module.userProgress?.lastAccessedAt ?? null
            }
          }
        }
        return module
      })
      updated.sort((a, b) => {
        const aTime = a.userProgress?.lastAccessedAt ? new Date(a.userProgress.lastAccessedAt).getTime() : 0
        const bTime = b.userProgress?.lastAccessedAt ? new Date(b.userProgress.lastAccessedAt).getTime() : 0
        return bTime - aTime
      })
      state.modules = updated
    }
  }
})

export const { setModules, setModuleProgress } = aiSkillsPractice.actions

export default aiSkillsPractice.reducer
